"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledProductTablePaginationStatus = exports.StyledProductTablePageNavigation = void 0;
const styles_1 = require("@mui/material/styles");
exports.StyledProductTablePageNavigation = (0, styles_1.styled)('div') `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  min-width: 0;
`;
exports.StyledProductTablePaginationStatus = (0, styles_1.styled)('div') `
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
`;
